import { getStopApi } from '../../../services/StopApi/StopApi';

export const getParticipantsList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        ids: index,
        key: item.key,
        id: item.id,
        lastName: item.lastName ? item.lastName : '',
        firstName: item.firstName ? item.firstName : '',
        middleName: item.middleName ? item.middleName : '',
        suffix: item.suffix,
        gender: item.gender,
        ethnicityOrRace: item.ethnicityOrRace,
        veteran: item.veteran,
        deployedCombatDuty: item.deployedCombatDuty,
        diagnosedPostTraumaticStressDisorder:
          item.diagnosedPostTraumaticStressDisorder,
        arsonist: item.arsonist,
        ssn: item.SSN ? item.SSN : '',
        dateOfBirth: item.dateOfBirth ? item.dateOfBirth.split('T')[0] : '',
        registration290: item.registration290,
        inactive: item.inactive,
      })),
    };
  }).catch((e) => alert(e));
};
